import React, { useState } from 'react';
import { useTheme } from '../../styles/ThemeProvider';
import { getPresetRange, toIsoDate } from '../../utils/analytics/dateRange';

const PRESETS = [
  { key: 'last30Days', label: 'Son 30 Gün' },
  { key: 'thisMonth', label: 'Bu Ay' },
  { key: 'lastMonth', label: 'Geçen Ay' },
  { key: 'last3Months', label: 'Son 3 Ay' },
  { key: 'last6Months', label: 'Son 6 Ay' },
  { key: 'ytd', label: 'Yılbaşından Beri' },
];

export const DateRangePicker = ({ value, onChange }) => {
  const { theme } = useTheme();
  const [custom, setCustom] = useState(false);
  const [start, setStart] = useState(value?.start || '');
  const [end, setEnd] = useState(value?.end || '');

  const pickPreset = (key) => {
    const r = getPresetRange(key);
    setCustom(false);
    onChange({ start: toIsoDate(r.start), end: toIsoDate(r.end), preset: key });
  };

  const applyCustom = () => {
    if (start && end) onChange({ start, end, preset: 'custom' });
  };

  return (
    <div style={{ display: 'flex', gap: theme.space.sm, alignItems: 'center', flexWrap: 'wrap' }}>
      {PRESETS.map((p) => (
        <button
          key={p.key}
          onClick={() => pickPreset(p.key)}
          style={{
            padding: `${theme.space.xs}px ${theme.space.md}px`,
            borderRadius: theme.radius.sm,
            border: `1px solid ${value?.preset === p.key ? theme.color.accent : theme.color.border}`,
            background: value?.preset === p.key ? theme.color.accent : theme.color.surface,
            color: value?.preset === p.key ? '#fff' : theme.color.text,
            fontSize: theme.font.size.xs,
            fontWeight: theme.font.weight.medium,
            cursor: 'pointer',
            fontFamily: theme.font.family,
          }}>
          {p.label}
        </button>
      ))}
      <button
        onClick={() => setCustom(!custom)}
        style={{
          padding: `${theme.space.xs}px ${theme.space.md}px`,
          borderRadius: theme.radius.sm,
          border: `1px solid ${custom || value?.preset === 'custom' ? theme.color.accent : theme.color.border}`,
          background: theme.color.surface,
          color: theme.color.text,
          fontSize: theme.font.size.xs,
          cursor: 'pointer',
          fontFamily: theme.font.family,
        }}>
        Özel
      </button>
      {custom && (
        <>
          <input type="date" value={start} onChange={(e) => setStart(e.target.value)} style={{ fontFamily: theme.font.family, padding: theme.space.xs, borderRadius: theme.radius.sm, border: `1px solid ${theme.color.border}` }} />
          <input type="date" value={end} onChange={(e) => setEnd(e.target.value)} style={{ fontFamily: theme.font.family, padding: theme.space.xs, borderRadius: theme.radius.sm, border: `1px solid ${theme.color.border}` }} />
          <button onClick={applyCustom} style={{
            padding: `${theme.space.xs}px ${theme.space.md}px`,
            background: theme.color.accent, color: '#fff', border: 'none',
            borderRadius: theme.radius.sm, cursor: 'pointer', fontFamily: theme.font.family,
          }}>Uygula</button>
        </>
      )}
    </div>
  );
};
